import { render, staticRenderFns } from "./Home2.0.vue?vue&type=template&id=4053ef8f&"
import script from "./Home2.0.vue?vue&type=script&lang=js&"
export * from "./Home2.0.vue?vue&type=script&lang=js&"
import style0 from "./Home2.0.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports